<template>
  <el-table
    :data="areaTable"
    border
    :header-cell-style="{ background: '#409EFF', color: '#fff', textAlign: 'center'}"
  >
    <!-- 展開按鈕 -->
    <el-table-column type="expand">
      <template slot-scope="props">

        <el-table
          :data="props.row.instruments"
          row-key="type"
          size="mini"
          border
          :header-cell-style="{ background: '#409EFF', color: '#fff', textAlign: 'center'}"
          :cell-style="rowStyle"
          class="sub-table"
        >
          <!-- 儀器類型（只有這欄顯示 header） -->
          <el-table-column
            label="儀器類型"
            min-width="30"
          >
            <template slot-scope="scope">
              {{ getContent(scope.row.type) }}
            </template>
          </el-table-column>

          <!-- 其餘欄位 header 不顯示（label 設為空字串） -->
          <el-table-column prop="instrument" label="儀器數量" min-width="30" />

          <el-table-column prop="GREEN" label="正常" min-width="30" />

          <el-table-column prop="AL" label="警戒值" min-width="30">
            <template slot-scope="scope">
              <div v-if="scope.row.AL !== 0">
                <el-popover placement="top" trigger="hover">
                  <div v-for="(AL, i) in scope.row.AL_name" :key="i">
                    <a :href="'/chart?instrument=' + scope.row.AL_id[i]" target="_blank">
                      <p class="multiline">{{ AL }}</p>
                    </a>
                  </div>
                  <span slot="reference">{{ scope.row.AL }}</span>
                </el-popover>
              </div>
              <span v-else>{{ scope.row.AL }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="WSL" label="行動值" min-width="30">
            <template slot-scope="scope">
              <div v-if="scope.row.WSL !== 0">
                <el-popover placement="top" trigger="hover">
                  <div v-for="(WSL, i) in scope.row.WSL_name" :key="i">
                    <a :href="'/chart?instrument=' + scope.row.WSL_id[i]" target="_blank">
                      <p class="multiline">{{ WSL }}</p>
                    </a>
                  </div>
                  <span slot="reference">{{ scope.row.WSL }}</span>
                </el-popover>
              </div>
              <span v-else>{{ scope.row.WSL }}</span>
            </template>
          </el-table-column>
        </el-table>

      </template>
    </el-table-column>

    <!-- 主表欄位（與子表格寬度一致） -->
    <el-table-column prop="area" label="區域名稱" min-width="20"></el-table-column>
    <el-table-column prop="total.instrument" label="儀器總數" min-width="20"></el-table-column>
    <el-table-column prop="total.GREEN" label="正常" min-width="20"></el-table-column>
    <el-table-column prop="total.AL" label="警戒值" min-width="20"></el-table-column>
    <el-table-column prop="total.WSL" label="行動值" min-width="20"></el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    projectData: {
      type: Object,
      default: () => ({}),
    },
    instrumentTypes: {
      type: Array,
      default: () => ['STI', 'MC', 'ELP', 'SAA', 'TM', 'LC', 'RAIN', 'DS', 'ETI', 'CG'],
    },
    onlyIoTStation: {
      type: Boolean,
      default: false,
    },
  },
  name: 'instrumentStatusTRA',
  data() {
    return {
      iotChart: '',
      instrumentList: [],
      instrumentGroup: [],
      allInstrument: [{
        type: 'TM',
        instrument: 0,
        GREEN: 0,
        WL: 0,
        AL: 0,
        AL_name: [],
        AL_id: [],
        WSL: 0,
        WSL_name: [],
        WSL_id: [],
        station: '',
      }, {
        type: 'RAIN',
        instrument: 0,
        GREEN: 0,
        WL: 0,
        AL: 0,
        AL_name: [],
        AL_id: [],
        WSL: 0,
        WSL_name: [],
        WSL_id: [],
        station: '',
      }, {
        type: 'STI',
        instrument: 0,
        GREEN: 0,
        WL: 0,
        AL: 0,
        AL_name: [],
        AL_id: [],
        WSL: 0,
        WSL_name: [],
        WSL_id: [],
        station: '',
      }, {
        type: 'ELP',
        instrument: 0,
        GREEN: 0,
        WL: 0,
        AL: 0,
        AL_name: [],
        AL_id: [],
        WSL: 0,
        WSL_name: [],
        WSL_id: [],
        station: '',
      }, {
        type: 'MC',
        instrument: 0,
        GREEN: 0,
        WL: 0,
        AL: 0,
        AL_name: [],
        AL_id: [],
        WSL: 0,
        WSL_name: [],
        WSL_id: [],
        station: '',
      }, {
        type: 'SAA',
        instrument: 0,
        GREEN: 0,
        WL: 0,
        AL: 0,
        AL_name: [],
        AL_id: [],
        WSL: 0,
        WSL_name: [],
        WSL_id: [],
        station: '',
      }, {
        type: 'LC',
        instrument: 0,
        GREEN: 0,
        WL: 0,
        AL: 0,
        AL_name: [],
        AL_id: [],
        WSL: 0,
        WSL_name: [],
        WSL_id: [],
        station: '',
      }, {
        type: 'DS',
        instrument: 0,
        GREEN: 0,
        WL: 0,
        AL: 0,
        AL_name: [],
        AL_id: [],
        WSL: 0,
        WSL_name: [],
        WSL_id: [],
        station: '',
      }, {
        type: 'ETI',
        instrument: 0,
        GREEN: 0,
        WL: 0,
        AL: 0,
        AL_name: [],
        AL_id: [],
        WSL: 0,
        WSL_name: [],
        WSL_id: [],
        station: '',
      }, {
        type: 'CG',
        instrument: 0,
        GREEN: 0,
        WL: 0,
        AL: 0,
        AL_name: [],
        AL_id: [],
        WSL: 0,
        WSL_name: [],
        WSL_id: [],
        station: '',
      }],
    };
  },
  mounted() {
    this.initAllInstrument();
    this.getProject();
  },
  computed: {
    selectedProject() {
      return this.$store.getters['project/selectedProject'];
    },
    finalInstrumentTypes() {
      return this.instrumentTypes;
    },
    areaTable() {
      if (!this.instrumentGroup || Object.keys(this.instrumentGroup).length === 0) {
        return [];
      }

      return this.projectData.area.map(area => {

        const areaInstruments = this.instrumentTypes.map(type => ({
          type,
          instrument: 0,
          GREEN: 0,
          AL: 0, AL_name: [], AL_id: [],
          WSL: 0, WSL_name: [], WSL_id: [],
          station: area.name,
        }));

        Object.values(this.instrumentGroup).forEach(group => {
          const firstItem = group[0];

          if (firstItem.station === area.name) {
            
            this.instrumentTypes.forEach(type => {
              if (firstItem.name.includes(type)) {
                
                const targetInst = areaInstruments.find(i => i.type === type);
                
                if (targetInst) {
                  let status = group.group_status;
                  if (status === 'down' || status === 'WL') status = 'GREEN';

                  targetInst.instrument += 1;
                  
                  if (targetInst[status] !== undefined) {
                    targetInst[status] += 1;
                  }

                  if (status === 'AL') {
                    targetInst.AL_name.push(firstItem.name);
                    targetInst.AL_id.push(firstItem.id);
                  } else if (status === 'WSL') {
                    targetInst.WSL_name.push(firstItem.name);
                    targetInst.WSL_id.push(firstItem.id);
                  }
                }
              }
            });
          }
        });

        // --- 重點修改位置：過濾數量為 0 的儀器 ---
        const filteredInstruments = areaInstruments.filter(inst => inst.instrument > 0);

        // 3. 計算總計 (建議用 areaInstruments 計算，確保總數包含所有類型，
        // 或用 filteredInstruments 也可以，結果是一樣的)
        const total = areaInstruments.reduce((sum, inst) => {
          sum.instrument += inst.instrument;
          sum.GREEN += inst.GREEN;
          sum.AL += inst.AL;
          sum.WSL += inst.WSL;
          return sum;
        }, { instrument: 0, GREEN: 0, AL: 0, WSL: 0 });

        return {
          area: area.name,
          instruments: filteredInstruments,
          total,
        };
      });
    },
  },
  methods: {
    initAllInstrument() {
      this.allInstrument = this.instrumentTypes.map(type => ({
        type,
        instrument: 0,
        GREEN: 0,
        WL: 0,
        AL: 0,
        AL_name: [],
        AL_id: [],
        WSL: 0,
        WSL_name: [],
        WSL_id: [],
        station: '',
      }));
    },
    drawChart() {
      let iotData = [
        { value: 0, name: '正常', itemStyle: '#67C23A' },
        { value: 0, name: '警戒值', itemStyle: '#E6A23C' },
        { value: 0, name: '行動值', itemStyle: '#F56C6C' },
      ];

      this.allInstrument.map(inst => {
        if (this.onlyIoTStation) {
          iotData[0].value += inst.GREEN;
          iotData[1].value += inst.AL;
          iotData[2].value += inst.WSL;
        } else {
          if (inst.type === 'STI' || inst.type === 'MC') {
            iotData[0].value += inst.GREEN;
            iotData[1].value += inst.AL;
            iotData[2].value += inst.WSL;
          }
        }
      });
      this.iotChart = this.$echarts.init(document.getElementById('iotChart'));
      this.iotChart.setOption(this.getChartOption('IoT 測站', iotData));
    },
    getChartOption(titleText, data) {
      const total = data.reduce((acc, cur) => acc + cur.value, 0);
      const percentages = data.map(item => {
        return (item.value / total * 100).toFixed(2);
      });
      
      let visible = {AL: false, WSL: false};

      visible.AL = data[1].value > 0 ? true : false;
      visible.WSL = data[2].value > 0 ? true : false;

      return {
        title: {
          text: titleText,
          subtext: '',
          x: 'right',
          y: 'top',
        },
        grid: { 
          containLabel: true,
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)',
        },
        color: ['#67C23A', '#E6A23C', '#F56C6C'],
        legend: {
          trigger: 'item',
          orient: 'vertical',
          icon: 'circle',
          align: 'left',
          inactiveColor :'#909399',
          x: 'right',
          y: 'bottom',
          formatter (name) {
            const index = data.findIndex(item => item.name === name);
            let percentage = percentages[index] || 0;
            if (isNaN(percentage))
              return `${name}  (0.00%)`;
            else 
              return `${name}  (${percentage}%)`;
          },
          data: ['正常', '警戒值', '行動值'],
          selected: {
            '警戒值': visible.AL,
            '行動值': visible.WSL,
          },
        },
        series: [
          {
            name: titleText,
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            center: ['40%', '50%'],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
              color(params) {
                const colorList = ['#67C23A', '#E6A23C', '#F56C6C'];
                return colorList[params.dataIndex];
              },
            },
            data,
          },
        ],
      };
    },
    getContent(type) {
      const typeMap = {
        'STI': 'STI 邊坡滑動監測桿',
        'MC': 'MC 土壤含水量計',
        'ELP': 'ELP 水壓計',
        'SAA': 'SAA 陣列式傾斜儀',
        'TM': 'TM 地滑計',
        'LC': 'LC 荷重計',
        'RAIN': 'RG 雨量計',
        'DS': 'DS 水位計',
        'ETI': 'ETI 傾斜計',
        'CG': 'CG 裂縫儀',
      };
      return typeMap[type] || type;
    },
    formattedALName(AL_name) {
      return AL_name.join('\n');
    },
    formattedWSLName(WSL_name) {
      return WSL_name.join('\n');
    },
    rowStyle() {
      return 'text-align:center';
    },
    incrementInstrument(instrumentArray, type, group_status, name, id, areaName) {
      const instrument = instrumentArray.find(inst => inst.type === type);

      if (instrument) {
        // 設定這個儀器屬於哪個 area
        instrument.station = areaName;

        instrument.instrument += 1;

        if (instrument[group_status] !== undefined) {
          instrument[group_status] += 1;

          if (group_status === 'AL') {
            instrument.AL_name.push(name);
            instrument.AL_id.push(id);
          } else if (group_status === 'WSL') {
            instrument.WSL_name.push(name);
            instrument.WSL_id.push(id);
          }
        }
      }
    },
    updateInstrument() {
      for (const group in this.instrumentGroup) {
        this.finalInstrumentTypes.forEach(type => {
          if (this.instrumentGroup[group][0].name.includes(type)) {
            var group_status;
            if(this.instrumentGroup[group].group_status === 'down' || this.instrumentGroup[group].group_status === 'WL' )
              group_status = 'GREEN';
            else group_status = this.instrumentGroup[group].group_status;
            
            const instrumentName = this.instrumentGroup[group][0].name;
            const instrumentId = this.instrumentGroup[group][0].id;
            this.incrementInstrument(this.allInstrument, type, group_status, instrumentName, instrumentId, this.instrumentGroup[group][0].station);
          }
        });
      }
    },
    getProject() {
      this.getInstrumentStatus(this.projectData, this.finalInstrumentTypes);
      this.getInstrumentGroup();
      this.updateInstrument();
      this.drawChart();
    },
    getInstrumentGroup() {
      const priorityOrder = ['down', 'WSL', 'AL', 'WL', 'GREEN'];

      this.instrumentGroup = this.instrumentList.reduce((acc, item) => {
        if (item.class !== '') {
          const uniqueKey = `${item.station}_${item.class}`;

          if (acc[uniqueKey]) {
            acc[uniqueKey].push(item);
            
            if(item.status === 'down' || item.status === 'WL') item.status = 'GREEN';
            
            // Determine group_status based on priorityOrder
            const itemPriority = priorityOrder.indexOf(item.status);
            const currentGroupStatusPriority = priorityOrder.indexOf(acc[uniqueKey].group_status);

            if (itemPriority < currentGroupStatusPriority) {
              acc[uniqueKey].group_status = item.status;
            }
          } else {
            acc[uniqueKey] = [item];
            // Initially set group_status to the item's status
            acc[uniqueKey].group_status = item.status;
          }
        }
        return acc;
      }, {});
    },
    getInstrumentStatus(data, type) {
      type.forEach(t => {
        data.area.map(area => {
          let type = 'iot';
          area.station.map(instruments => {
            const instru = instruments.instrument.filter(item => item.latestVersion.name.includes(t) && !item.latestVersion.name.includes('Batt'))
              .map(item => ({
                name: item.latestVersion.name,
                status: item.status,
                class: item.latestVersion.class,
                id: item._id,
                type,
                station: area.name,
              }));
            this.instrumentList.push(...instru);
          });
        });
      });
    },
  },
};
</script>

<style>
  .multiline {
    white-space: pre-line;
  }
  .sub-table {
    margin-left: 0 !important;
    width: 100% !important;
  }

  .multiline {
    white-space: pre-line;
  }

</style>